import { ApolloCache } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { toast } from "react-toastify";
import { StatefulButton } from "../../components/ui/muiButtons";
import type { SaveEmailMatchMutationVariables } from "../../graphql/types";
import { SaveEmailMatchDocument, SaveEmailMatchMutation } from "../../graphql/types";

type DeactivateRuleWarningModalProps = {
  ruleId: string;
  open: boolean;
  onCancel: () => void;
  onClose: () => void;
  updateCache: (
    cache: ApolloCache,
    {
      data,
    }: {
      data?: SaveEmailMatchMutation | null;
    }
  ) => void;
};

const DeactivateRuleWarningModal = ({
  ruleId,
  open,
  onCancel,
  onClose,
  updateCache,
}: DeactivateRuleWarningModalProps) => {
  const [saveEmailMatch, { loading }] = useMutation<SaveEmailMatchMutation, SaveEmailMatchMutationVariables>(
    SaveEmailMatchDocument,
    {
      onCompleted: (data) => {
        if (data?.save_emailmatch?.__typename === "SaveEmailMatchOk") {
          toast.success("Successfully updated rules for recipient");
          onClose();
        }
      },
      update: updateCache,
    }
  );

  const handleDeactivate = () => {
    saveEmailMatch({
      variables: {
        id: ruleId,
        deactivate: true,
      },
    });
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Delete Rule</DialogTitle>
      <DialogContent>Are you sure you want to delete this rule?</DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button variant="text" onClick={onCancel}>
          Cancel
        </Button>
        <StatefulButton loading={loading} onClick={handleDeactivate} aria-label="Confirm rule deletion">
          Delete
        </StatefulButton>
      </DialogActions>
    </Dialog>
  );
};

export { DeactivateRuleWarningModal };
